import { IHeadCell } from 'components/table/EnhancedTableHead';
import { S3ClusterItem } from 'models/s3BucketCluster/dto';

const tableConfig: IHeadCell<S3ClusterItem>[] = [
	{
		id: 'name',
		numeric: false,
		label: 'Name',
		sortable: false,
	},
	{
		id: 'action',
		numeric: false,
		label: '',
		sortable: false,
	},
	{
		id: 'type',
		numeric: false,
		label: 'Type',
		sortable: false,
	},
	{
		id: 'size',
		numeric: true,
		label: 'Size',
		sortable: false,
	},
	{
		id: 'sensitivity',
		numeric: false,
		label: 'Sensitivity',
		sortable: false,
	},
	{
		id: 'data_types',
		numeric: false,
		label: 'Data types',
		sortable: false,
	},
	{
		id: 'action',
		numeric: false,
		label: '',
		sortable: false,
	},
];

export default tableConfig;
